<script setup lang="ts">
import LinkVariantIcon from 'vue-material-design-icons/LinkVariant.vue';
import { useSwal } from '~/composables/useSwal';

const props = defineProps<{
  url: string;
}>();

const { successToast, errorToast } = useSwal();

async function copyUrl() {
  try {
    await navigator.clipboard.writeText(props.url);
    void successToast({ title: 'この記事のリンクをコピーしました' });
  } catch {
    void errorToast({ title: 'リンクのコピーに失敗しました' });
  }
}
</script>

<template>
  <button
    type="button"
    class="inline-flex items-center gap-1 h-5 px-2 rounded-full bg-gray-500 text-white text-xs font-bold hover:opacity-60 duration-300"
    @click="copyUrl"
  >
    <LinkVariantIcon :size="14" />
    <!-- NOTE: フォントの上下の余白が非対称で字面が上に寄って見えるため、文字の箱を字面に合わせて切り詰めてから中央に揃えている -->
    <span class="[text-box:trim-both_cap_alphabetic]">
      この記事のリンクをコピー
    </span>
  </button>
</template>
